/**
 * Origine API sans découpage fragile (évite https://api-… → "https:/").
 */
export function getApiOrigin(apiUrl) {
  if (!apiUrl || typeof apiUrl !== 'string') return '';
  const normalized = apiUrl.trim().replace(/\/$/, '');
  if (normalized.startsWith('/')) return normalized;
  try {
    const parsed = new URL(normalized);
    return `${parsed.protocol}//${parsed.host}`;
  } catch {
    return normalized.replace(/\/api\/?$/, '') || normalized;
  }
}
